exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1fZjk{height:60px;-webkit-box-shadow:0 2px 4px 0 rgba(133,138,180,.14)!important;box-shadow:0 2px 4px 0 rgba(133,138,180,.14)!important;background:#fff;position:absolute;width:100%;left:0;top:0}._3NQ3r{float:left;padding:20px;-webkit-transition:all .3s;-o-transition:all .3s;transition:all .3s;cursor:pointer}._3NQ3r:hover{background:#f5f5f5}._3NQ3r i{font-size:20px;font-weight:700}._21BdT{height:60px;padding-right:20px;overflow:hidden}", ""]);

// exports
exports.locals = {
	"wrap": "_1fZjk",
	"collapse": "_3NQ3r",
	"container": "_21BdT"
};